module.exports = __webpack_public_path__ + "static/lframe-new-and-used-car-loans-18e7fc5b346b8047199a40b7600478cf.png";